import { USER_REGISTRATION_DATA } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case USER_REGISTRATION_DATA:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userRegistrationDetails.js